
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[authorUsername]/[cycleSlug]",
      function () {
        return require("private-next-pages/series/[authorUsername]/[cycleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[authorUsername]/[cycleSlug]"])
      });
    }
  